import React from "react";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import "@cyntler/react-doc-viewer/dist/index.css";
import AttachmentPreviewSkeleton from "./PreviewSkeleton";

type DocPreviewProps = {
  fileUrl?: string;
  fileName?: string;
};

const DocPreview: React.FC<DocPreviewProps> = ({ fileUrl, fileName }) => {
  if (!fileUrl) {
    return <AttachmentPreviewSkeleton />;
  }

  return (
    <main className="h-full min-h-0 w-full bg-gray-100 overflow-auto">
      <div className="h-full w-full p-6 flex justify-center">
        <div className="h-full w-full max-w-full overflow-hidden">
          <DocViewer
            pluginRenderers={DocViewerRenderers}
            documents={[
              {
                uri: fileUrl,
                fileName: fileName || "Attachment",
              },
            ]}
            config={{
              header: {
                disableHeader: true,
                disableFileName: true,
                retainURLParams: true,
              },
            }}
          />
        </div>
      </div>
    </main>
  );
};

export default DocPreview;
